function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef, useState, useMemo } from 'react';
import styles from './VideoPlayer.module.scss';
import I18n from '../I18n/I18n/I18n';
import cs from 'classnames';
import AdditionalIntl from '../I18n/AdditionalIntl/AdditionalIntl';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import en from './locales/VideoPlayer.en.json';
export default function VideoPlayer(_ref) {
  var controls = _ref.controls,
    caption = _ref.caption,
    children = _ref.children,
    _ref$captionHidden = _ref.captionHidden,
    captionHidden = _ref$captionHidden === void 0 ? false : _ref$captionHidden,
    attrs = _objectWithoutProperties(_ref, ["controls", "caption", "children", "captionHidden"]);
  var videoRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var messages = useMemo(function () {
    return normalizeLocaleData(en, '@dm/components.video');
  }, []);
  function toggleVideo() {
    var video = videoRef.current;
    if (video) {
      if (video.paused || video.ended) {
        video.play();
        setIsPlaying(true);
      } else {
        video.pause();
        setIsPlaying(false);
      }
    }
  }
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    path: "VideoPlayer/locales/VideoPlayer",
    namespace: "@dm/components.video"
  }, /*#__PURE__*/React.createElement("figure", {
    className: styles.figure
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("video", Object.assign({}, attrs, {
    className: styles.video,
    controls: controls,
    ref: videoRef
  }), children), !controls && /*#__PURE__*/React.createElement("button", {
    className: cs(styles.button, _defineProperty(_defineProperty({}, styles.play, !isPlaying), styles.pause, isPlaying)),
    onClick: toggleVideo,
    "aria-live": "polite",
    "aria-relevant": "text"
  }, /*#__PURE__*/React.createElement("span", {
    className: cs(styles.icon, _defineProperty(_defineProperty({}, styles["icon--play"], !isPlaying), styles["icon--pause"], isPlaying))
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.video.".concat(isPlaying ? 'pause' : 'play')
  })))), /*#__PURE__*/React.createElement("figcaption", {
    className: captionHidden ? 'assistive-text' : ''
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: caption
  }))));
}